import { THEME } from 'styles/themes';

export const colors = THEME.BusinessCard?.colors ?? {};

export const options = {
  hasIcons: true,
  hasProfile: true,
  ...(THEME.BusinessCard?.options ?? {}),
};
